const path = `/v2/organization/billing`;
/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  async function get() {
    const response = await repository.get(path);
    return response.data && response.data ? response.data.account : {};
  }
  async function getDetails() {
    const response = await repository.get(path);
    return response.data && response.data ? response.data : {};
  }
  return Object.freeze({
    get,
    getDetails
  });
}
